export const idxWithoutLulucfColor = 0;

export const idxWithLulucfColor = 1;
